<template>
  <div>
    <slot :openModal="openModal">
      <button class="btn-reset btn-link" @click.prevent.stop="showAvatarEditModal = true">
        <span>Change Image</span>
      </button>
    </slot>


    <b-modal v-model="showAvatarEditModal" title="Profile Avatar" hide-footer size="lg">
      <onboarding-avatar-edit @cancel="showAvatarEditModal = false" @saved="handleAvatarChanged"/>
    </b-modal>
  </div>
</template>

<script>
import GeneralMixins from "../../../mixins/GeneralMixins";
import OnboardingAvatarEdit from "../Onboarding/OnboardingAvatarEdit.vue";

export default {
  components: {OnboardingAvatarEdit},
  props: ['usersUrl', 'paramName'],
  mixins: [GeneralMixins],

  data() {
    return {
      showAvatarEditModal: false
    }
  },

  methods: {
    openModal() {
      this.showAvatarEditModal = true
    },
    handleAvatarChanged() {
      window.location.reload()
    }
  }
}
</script>